import { ReactElement } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";

import useIntersectionObserver from "../../hooks/useIntersectionObserver";

const ViewportAwareRenderer = ({
  component,
  getComponent,
}: {
  component: any;
  getComponent: (c: any) => ReactElement;
}) => {
  const { projectClass } = useUiContext();
  const [isVisible, elementRef] = useIntersectionObserver({
    rootMargin: "50%",
    threshold: 0.001,
  });

  return (
    <div
      ref={elementRef}
      className={`${projectClass}_ViewportAwareRenderer`}
      data-component={component.type}
    >
      {isVisible ? getComponent(component) : null}
    </div>
  );
};

export default ViewportAwareRenderer;
